// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-media-player {
  width: 400px;
  z-index: 1000;
  position: absolute;
  bottom: 13%;
  left: 4%;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: fadeInLeft;
  box-shadow: 0 -3px 5px 0px rgba(62, 85, 161, 0.31), 0 0 0 1px rgba(62, 85, 161, 0);
}
.cs-media-player i.vid-close {
  position: absolute;
  right: 0;
  padding: 10px;
  color: #fff;
  z-index: 1000;
  cursor: pointer;
  display: none;
  text-align: right;
  opacity: 0.5;
  background: #000;
}
.cs-media-player i.aud-close {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  justify-content: center;
  height: 50px;
  width: 40px;
  cursor: pointer;
  color: white;
  line-height: 50px;
}

.cs-media-player:hover i.fa-times {
  display: block;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/media-player/media-player-component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EAEA,wBAAA;EAEA,yBAAA;EACA,0BAAA;EACA,kFAAA;AACJ;AAAG;EACC,kBAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;AAAG;EACC,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AAOA;EACI,cAAA;AAJJ;;AAMA;EACI;IACE,UAAA;IAEA,mCAAA;EAHJ;EAME;IACE,UAAA;IAEA,eAAA;EAJJ;AACF","sourcesContent":[".cs-media-player {\n    width: 400px;\n    z-index: 1000;\n    position: absolute;\n    bottom: 13%;\n    left: 4%;\n    -webkit-animation-duration: 0.3s;\n    animation-duration: 0.3s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    animation-name: fadeInLeft;\n    box-shadow: 0 -3px 5px 0px rgba(62, 85, 161, 0.31), 0 0 0 1px rgba(62, 85, 161, 0);\n   i.vid-close{\n    position: absolute;\n    right: 0;\n    padding: 10px;\n    color: #fff;\n    z-index: 1000;\n    cursor: pointer;\n    display: none;\n    text-align: right;\n    opacity: 0.5;\n    background: #000;\n   }\n   i.aud-close {\n    user-select: none;\n    display: flex;\n    justify-content: center;\n    height: 50px;\n    width: 40px;\n    cursor: pointer;\n    color: white;\n    line-height: 50px;\n   }\n  //  audio {\n  //   width: 400px;\n  //   height: 34px;\n  //   padding: 1px;\n  //   background: #d8d2d2;\n  //  }\n}\n.cs-media-player:hover i.fa-times{\n    display: block;\n}\n@keyframes fadeInLeft {\n    from {\n      opacity: 0;\n      -webkit-transform: translate3d(-100%, 0, 0);\n      transform: translate3d(-100%, 0, 0);\n    }\n  \n    to {\n      opacity: 1;\n      -webkit-transform: none;\n      transform: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
